
import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [language, setLanguage] = useState('fr');

  const slides = [
    {
      image: "https://public.readdy.ai/ai/img_res/00f3cccc1e84fa4704482d277274fe28.jpg",
      titleFr: "Dépannage Automobile",
      titleAr: "إصلاح السيارات",
      subtitleFr: "Service 24h/7j par des mécaniciens qualifiés",
      subtitleAr: "خدمة 24 ساعة من ميكانيكيين مؤهلين"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Skilled%20handyman%20from%20Maghreb%20community%20repairing%20home%20plumbing%20and%20electrical%20systems%20in%20modern%20French%20house%20interior%2C%20professional%20tools%20and%20equipment%2C%20quality%20craftsmanship%20representing%20reliable%20home%20repair%20services%20in%20Rouen&width=1920&height=1080&seq=hero-repair&orientation=landscape",
      titleFr: "Réparation Domicile",
      titleAr: "إصلاح المنزل",
      subtitleFr: "Plomberie, électricité, peinture par des artisans expérimentés",
      subtitleAr: "السباكة والكهرباء والطلاء من حرفيين ذوي خبرة"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Caring%20North%20African%20caregiver%20helping%20elderly%20person%20with%20daily%20activities%20in%20comfortable%20home%20setting%2C%20warm%20atmosphere%2C%20professional%20healthcare%20assistance%20representing%20quality%20eldercare%20services%20in%20Rouen%20France&width=1920&height=1080&seq=hero-eldercare&orientation=landscape",
      titleFr: "Aide à Domicile",
      titleAr: "المساعدة المنزلية",
      subtitleFr: "Accompagnement bienveillant pour personnes âgées",
      subtitleAr: "مرافقة رعاية لكبار السن"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20from%20Maghreb%20community%20working%20in%20modern%20office%20space%20with%20eco-friendly%20cleaning%20supplies%2C%20bright%20clean%20environment%2C%20teamwork%20representing%20quality%20cleaning%20services%20in%20Rouen%20France&width=1920&height=1080&seq=hero-cleaning&orientation=landscape",
      titleFr: "Services de Nettoyage",
      titleAr: "خدمات التنظيف",
      subtitleFr: "Nettoyage professionnel avec produits écologiques",
      subtitleAr: "تنظيف مهني بمنتجات صديقة للبيئة"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20translator%20and%20administrative%20assistant%20from%20North%20African%20community%20helping%20with%20official%20documents%20and%20paperwork%20in%20modern%20office%20setting%2C%20representing%20translation%20and%20administrative%20services%20in%20Rouen%20France&width=1920&height=1080&seq=hero-admin&orientation=landscape",
      titleFr: "Démarches Administratives",
      titleAr: "الإجراءات الإدارية",
      subtitleFr: "Traduction et accompagnement pour vos démarches",
      subtitleAr: "ترجمة ومرافقة لإجراءاتكم"
    },
    {
      image: "https://readdy.ai/api/search-image?query=Professional%20childcare%20provider%20from%20Maghreb%20community%20playing%20educational%20games%20with%20happy%20children%20in%20bright%20colorful%20playroom%2C%20toys%20and%20learning%20materials%2C%20safe%20nurturing%20environment%20representing%20quality%20childcare%20services&width=1920&height=1080&seq=hero-childcare&orientation=landscape",
      titleFr: "Garde d'Enfants",
      titleAr: "رعاية الأطفال",
      subtitleFr: "Garde professionnelle avec activités éducatives",
      subtitleAr: "رعاية مهنية مع أنشطة تعليمية"
    }
  ];

  const content = {
    fr: {
      mainTitle: "Entraide Communautaire Maghrébine",
      subtitle: "Wald Bladi",
      description: "Besoin d'un coup de main ? Notre communauté est là pour vous ! Services de dépannage express en 1-2h entre voisins maghrébins à Rouen.",
      searchPlaceholder: "Rechercher un service, dépannage, aide...",
      searchButton: "Trouver de l'aide",
      stats: {
        services: "Services disponibles",
        helpers: "Membres aidants",
        requests: "Demandes résolues"
      }
    },
    ar: {
      mainTitle: "التعاون المجتمعي المغاربي",
      subtitle: "ولد بلادي",
      description: "تحتاج مساعدة؟ مجتمعنا هنا من أجلك! خدمات الإصلاح السريع في 1-2 ساعة بين الجيران المغاربة في روان.",
      searchPlaceholder: "البحث عن خدمة، إصلاح، مساعدة...",
      searchButton: "العثور على مساعدة",
      stats: {
        services: "الخدمات المتاحة",
        helpers: "الأعضاء المساعدون",
        requests: "الطلبات المحلولة"
      }
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const currentContent = content[language as keyof typeof content];
  const currentSlideData = slides[currentSlide];
  const isRTL = language === 'ar';

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Slides */}
      <div className="relative w-full h-screen">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div
              className="w-full h-full bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url('${slide.image}')` }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Content Overlay */}
      <div className="absolute inset-0 z-10 flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-4xl mx-auto">
            {/* Language Toggle */}
            <div className="flex justify-center mb-8">
              <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-lg p-1">
                <button
                  onClick={() => setLanguage('fr')}
                  className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                    language === 'fr' 
                      ? 'bg-white text-orange-600 shadow-lg' 
                      : 'text-white hover:bg-white/20'
                  }`}
                >
                  Français
                </button>
                <button
                  onClick={() => setLanguage('ar')}
                  className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                    language === 'ar' 
                      ? 'bg-white text-orange-600 shadow-lg' 
                      : 'text-white hover:bg-white/20'
                  }`}
                >
                  العربية
                </button>
              </div>
            </div>

            {/* Service Title */}
            <div className={`mb-8 ${isRTL ? 'text-right' : 'text-left'} md:text-center`} dir={isRTL ? 'rtl' : 'ltr'}>
              <h3 className="text-2xl md:text-4xl font-bold text-orange-300 mb-2">
                {isRTL ? currentSlideData.titleAr : currentSlideData.titleFr}
              </h3>
              <p className="text-lg md:text-xl text-gray-200">
                {isRTL ? currentSlideData.subtitleAr : currentSlideData.subtitleFr}
              </p>
            </div>

            {/* Main Content */}
            <div className={language === 'ar' ? 'text-right' : 'text-left'} dir={language === 'ar' ? 'rtl' : 'ltr'}>
              <h2 className="text-2xl md:text-3xl font-bold text-orange-300 mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
                Wald bladi : ولد بلادي
              </h2>
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                {currentContent.mainTitle}
              </h1>
              <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
                {currentContent.description}
              </p>
            </div>

            {/* Search Bar */}
            <div className="max-w-2xl mx-auto mb-16">
              <div className="bg-white rounded-2xl shadow-2xl p-2 flex flex-col sm:flex-row gap-2">
                <div className="flex-1 relative">
                  <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                  <input
                    type="text"
                    placeholder={currentContent.searchPlaceholder}
                    className="w-full pl-12 pr-4 py-4 text-gray-700 bg-transparent border-none outline-none text-lg"
                  />
                </div>
                <button className="bg-orange-600 text-white px-8 py-4 rounded-xl hover:bg-orange-700 transition-colors font-semibold text-lg cursor-pointer whitespace-nowrap shadow-lg">
                  <i className="ri-search-line mr-2"></i>
                  {currentContent.searchButton}
                </button>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">50+</div>
                <div className="text-orange-200 font-medium text-lg">{currentContent.stats.services}</div>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">200+</div>
                <div className="text-orange-200 font-medium text-lg">{currentContent.stats.helpers}</div>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">800+</div>
                <div className="text-orange-200 font-medium text-lg">{currentContent.stats.requests}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className={`absolute ${isRTL ? 'right-4' : 'left-4'} top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all cursor-pointer z-20`}
        aria-label="Slide précédent"
      >
        <i className={`ri-arrow-${isRTL ? 'right' : 'left'}-line text-xl`}></i>
      </button>

      <button
        onClick={nextSlide}
        className={`absolute ${isRTL ? 'left-4' : 'right-4'} top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all cursor-pointer z-20`}
        aria-label="Slide suivant"
      >
        <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line text-xl`}></i>
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide 
                ? 'bg-white scale-125' 
                : 'bg-white/50 hover:bg-white/75'
            }`}
            aria-label={`Aller au slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Progress Bar */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-white/20 z-20">
        <div 
          className="h-full bg-orange-400 transition-all duration-6000 ease-linear"
          style={{ 
            width: `${((currentSlide + 1) / slides.length) * 100}%`,
            animation: currentSlide === slides.length - 1 ? 'none' : undefined
          }}
        />
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
